<!-- 著作权 -->
<template>
  <div class="cr_wrap">
    <img
      :src="`${apiObj.VUE_APP_BASE_CDN+imgPtah}`"
      class="cr_img"
    >
    <!-- <div class="cr_body">
      <div class="cr_content">
        <img
          :src="IMG_LOGO_SUPPORT"
          class="cr_img"
        >
        <div class="cr_text_wrap">
          <div class="cr_text">技术支持</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import apiObj from '@a/js/api.js';
export default {
  name: 'PCopyright',
  data() {
    return {
      apiObj,
      IMG_LOGO_SUPPORT: require('@/assets/img/logo/logo.png'),
      imgPtah: '/system/image/init/version/bhj_mobile_version.png'
    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.cr_wrap {
  background: #fafcff;
  height: 70px;
  width: 100vw;
  position: relative;
  text-align: center;
  .cr_img {
    height: 100%;
  }
}
</style>